module.exports = __webpack_public_path__ + "static/media/oberflex.e817dafc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/oberflex.svg
// module id = 1152
// module chunks = 37